import React from 'react';

export const AddSquareIcon = ({ width = '25', height = '25', background = 'currentColor', fill = 'black' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
    <path fill={background} d="M0 0h25v25H0z" />
    <path fill={fill} d="M11 6.545h2v13h-2z" />
    <path fill={fill} d="M18.5 12.023v2h-13v-2z" />
  </svg>
);
